export default {
  submit: '提 交',
  save: '保 存',
  close: '关闭',
  loading: "处理中...",
  header: {
    allProduct: "商品分类",
    searchPlaceholder: "请输入搜索内容",
    accountOrder: "我的订单",
    accountCollect: "我的收藏",
    accountIntegral: "我的积分",
    accountCoupon: "我的优惠券",
    logout: "退出登录",
    hotRecommend: '热门推荐',
    searchHistory: '搜索记录',
    empty: '清空',
    more: '更多'
  },
  page: {
    pagesize: '条/页',
    goto: '前往',
    pageClassifier: '页',
    total: '共 {total} 条'
  },
  image: {
    error: '加载失败'
  },
  upload: {
    deleteTip: '删除JP'
  },
  selectRegion: {
    userAddressTitle: "常用地址",
    selectAddressTitle: "选择地址"
  },
  yes: '是',
  no: '否',
  sellOff: '特卖品',
  verticalReductionActivity: '满减',
  discountActivity: '满折',
  verticalReductionActivityCoupon: '满减券',
  discountActivityCoupon: '满折券',
  freeShippingyCoupon: '包邮券',
  addShoppingCart: '加入购物车',
  pointNumber: '{productPointNum}倍积分',
  stockout: '补货中',
  edit: '编辑',
  delete: '删除',
  pleaseSelect: '请选择',
  pleaseInput: '请输入',
  confirm: '确定',
  cancel: '取消',
  detail: '详情',
  productName: '商品名称',
  productNo: '商品编号',
  specification: '规格',
  orderNo: '订单编号',
  amount: '数量',
  productPrice: '单价',
  subtotal: '商品小计',
  productSubtotal: '商品小计',
  coupon: '优惠券',
  freight: '运费',
  totalPrice: '总价',
  prompt: '提示',
  orderStatus1: "待支付",
  orderStatus2: "待处理",
  orderStatus3: "发货准备",
  orderStatus4: "发货准备",
  //拣货中,前台不显示这个状态
  orderStatus5: "已发货",
  orderStatus6: "已完成",
  orderStatus7: "已取消",
  commonHint: '提醒',
  noRecord: '没有记录哦！',
  addCartSuccess: '加入购物车成功',
  unSet: '不指定',
  beforeNoon: '午前',
  captchaSentSuccessfully: '验证码发送成功',
  OYX: '验证通过',
  updateSuccessfully: '更新成功',
  addSuccessfully: '新建成功',
  deleteSuccessfully: '删除成功',
  thousand: '千',
  tenThousand: '万',
  fastTimeRecive: '最短时间送达',
  selectReciveDate: '请选择指定收货时间',
  couponList: '优惠券列表',
  footer: {
    informationConsultantTitle: "信息咨询",
    informationConsultant1: "优惠券使用方法",
    informationConsultant2: "大量采购",
    informationConsultant3: "常见问题",
    informationConsultant4: "便利商店付款",
    informationConsultant5: "诚招供应商",
    shoppingRelatedTitle: "购物相关",
    shoppingRelated1: "每月特惠",
    shoppingRelated2: "积分介绍",
    shoppingRelated3: "购物须知",
    customerServiceTitle: "客户服务",
    customerService1: "历史订单",
    customerService2: "收藏列表",
    customerService3: "订阅资讯",
    otherTitle: "其他",
    other1: "关于我们",
    footer1: "条款与条件",
    footer2: "特定商取引法",
    footer3: "隐私政策"
  },
  timeOutTip: "请求超时",
  no_coupon: '暂无优惠券',
  no_existence_coupon: '该优惠券不存在',
  information: "文章",
  accessPasswordNull: '请输入访问密码',
  indexPage: '首页',
  check_article_exist: "该文章不存在",
  offShelves: "已下架",
  levelUpTip1: "当前您访问的是本味主义测试站点，请点击",
  levelUpTip2: "跳转到正式站点",
  bunding: '同捆'
};